import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../../components/layout"
import FluidContainer from "../../components/fluidContainer"
import ArticleCard from "../../components/Cards/article"
import styled from "@emotion/styled"
import ContentContainer from "../../components/contentContainer"
import { Header1, Paragraph } from "../../components/headings"
import Banner from "../../components/banner"
import SEO from "../../components/seo"
import { pressReleaseSNs } from "../../utils/pressReleases"

const ArticlesList = styled.ul`
  justify-content: space-between;
  margin: 0;
  li {
    width: 100%;
    list-style: none;
    margin-bottom: 0;
    a {
      text-decoration: none;
    }
  }
  @media (max-width: 768px) {
    display: block;
  }
`

const PressReleasesPage = ({ data }) => {
  const releases = data.allStrapiArticles.edges.filter(({ node }) =>
    pressReleaseSNs.includes(node.sn)
  )
  return (
    <Layout>
      <FluidContainer>
        <SEO
          title="Press Releases"
          keywords={[`eating`, `contests`, `official`, `press release`]}
        />
        <Banner img={data.placeholderImage.childImageSharp.fluid}>
          <Header1>Press Releases</Header1>
          <Paragraph>
            Official press releases from Major League Eating, the world
            governing body of all stomach-centric sports.
          </Paragraph>
        </Banner>
        <ContentContainer>
          <ArticlesList>
            {releases.map(document => (
              <li key={document.node.id}>
                <Link to={`/articles/${document.node.sn}`}>
                  <ArticleCard {...document.node} />
                </Link>
              </li>
            ))}
            {releases.length === 0 && (
              <li>
                <Paragraph style={{ padding: "2rem", textAlign: "center" }}>
                  No press releases yet.
                </Paragraph>
              </li>
            )}
          </ArticlesList>
        </ContentContainer>
      </FluidContainer>
    </Layout>
  )
}

export default PressReleasesPage

export const pageQuery = graphql`
  query PressReleasesQuery {
    allStrapiArticles(sort: { fields: [createdAt], order: [DESC] }) {
      edges {
        node {
          id
          sn
          title
          createdAt
          coverPhoto {
            childImageSharp {
              fixed(width: 600) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          content
        }
      }
    }
    placeholderImage: file(relativePath: { eq: "news-banner.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
